export enum Permission {
  ADMIN = 'ADMIN',
  ZAEHLPUNKTE = 'ZAEHLPUNKTE',
  RECHNUNGEN = 'RECHNUNGEN',
  UNTERNEHMENSDATEN = 'UNTERNEHMENSDATEN',
}

export interface PermissionDetail {
  permission: Permission;
  hasPermission: boolean;
}
